<div class="d-flex justify-content-center" *ngIf="loading">
  <i class="fas fa-spinner fa-spin fa-3x"></i>
</div>

<form *ngIf="!loading" (ngSubmit)="form.valid && onSubmit()" autocomplete="off" #form="ngForm">
  <div class="form-group form-row">
    <label for="organization" class="col-md-4 col-sm-12 col-form-label">Organization</label>
    <div class="col-md-8 col-sm-12">
      <input
        [value]="user.organization?.orgName || ''"
        type="text"
        class="form-control"
        id="organization"
        name="organization"
        readonly
      />
    </div>
  </div>

  <div class="form-group form-row required">
    <label for="firstName" class="col-md-4 col-form-label">First Name</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.firstName"
        type="text"
        class="form-control"
        name="firstName"
        id="firstName"
        #firstName="ngModel"
        [readonly]="!hasUpdateUserNamePermission || editAuthenticatedUser"
        required
      />
      <div *ngIf="form.submitted && firstName.invalid" class="invalid-feedback">Please provide a first name</div>
    </div>
  </div>

  <div class="form-group form-row required">
    <label for="lastName" class="col-md-4 col-form-label">Last Name</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.lastName"
        type="text"
        class="form-control"
        name="lastName"
        id="lastName"
        #lastName="ngModel"
        [readonly]="!hasUpdateUserNamePermission || editAuthenticatedUser"
        required
      />
      <div *ngIf="form.submitted && lastName.invalid" class="invalid-feedback">Please provide a last name</div>
    </div>
  </div>

  <div class="form-group form-row required">
    <label for="userName" class="col-md-4 col-form-label">Username</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.userName"
        type="text"
        class="form-control"
        name="userName"
        id="userName"
        #userName="ngModel"
        [readonly]="!hasUpdateUserNamePermission || editAuthenticatedUser"
        required
      />
      <div *ngIf="form.submitted && userName.invalid" class="invalid-feedback">Please provide a valid username</div>
    </div>
  </div>

  <div *ngIf="formFieldsEnabled.nickName" class="form-group form-row required">
    <label for="nickName" class="col-md-4 col-form-label">Nick Name</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.nickName"
        type="text"
        class="form-control"
        name="nickName"
        id="nickName"
        #nickName="ngModel"
        required
      />

      <div *ngIf="form.submitted && nickName.invalid" class="invalid-feedback">Please provide a nick name</div>
    </div>
  </div>

  <ng-container *ngIf="formFieldsEnabled.password && !editAuthenticatedUser && hasUpdateUserPasswordPermission">
    <div class="form-group form-row">
      <label for="password" class="col-md-4 col-form-label">Password</label>
      <div class="col-md-8">
        <input
          #parentPass
          [(ngModel)]="user.password"
          [pattern]="passwordPattern"
          type="password"
          class="form-control"
          name="password"
          id="password"
          #password="ngModel"
          autocomplete="new-password"
        />
        <div *ngIf="form.submitted && password.invalid" class="invalid-feedback">
          <div *ngIf="password?.errors.pattern">
            {{ passwordPatternError }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group form-row">
      <label for="confirmPassword" class="col-md-4 col-form-label">Confirm Password</label>
      <div class="col-md-8">
        <input
          [(ngModel)]="user.confirmPassword"
          type="password"
          class="form-control"
          name="confirmPassword"
          id="confirmPassword"
          #confirmPassword="ngModel"
          [thConfirmEqualValidator]="parentPass"
          autocomplete="new-password"
        />
        <div *ngIf="form.submitted && confirmPassword.invalid" class="invalid-feedback">
          <div *ngIf="confirmPassword?.errors?.notEqual && confirmPassword.touched">
            Please enter the same password as above
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="formFieldsEnabled.passphrase && editAuthenticatedUser" class="form-group form-row required">
    <label for="passPhrase" class="col-md-4 col-form-label">Passphrase</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.passPhrase"
        type="text"
        class="form-control"
        name="passPhrase"
        id="passPhrase"
        #passPhrase="ngModel"
        [maxlength]="passPhraseMaxLength"
        [readonly]="editAuthenticatedUser"
        required
      />

      <div *ngIf="form.submitted && passPhrase.invalid" class="invalid-feedback">Please provide a passphrase</div>
    </div>
  </div>

  <div *ngIf="formFieldsEnabled.securityQuestion" class="form-group form-row required">
    <label for="challengeQuestion" class="col-md-4 col-form-label">Security Question</label>
    <div class="col-md-8">
      <select
        class="form-select"
        [(ngModel)]="user.challengeQuestion"
        name="challengeQuestion"
        id="challengeQuestion"
        #challengeQuestionModel="ngModel"
        required
      >
        <option [ngValue]="null" disabled>Please select a challenge question</option>
        <option *ngFor="let challengeQuestion of challengeQuestions" [ngValue]="challengeQuestion">
          {{ challengeQuestion }}
        </option>
      </select>
      <div *ngIf="form.submitted && challengeQuestionModel.invalid" class="invalid-feedback">
        Please provide a challenge question
      </div>
    </div>
  </div>

  <div *ngIf="formFieldsEnabled.securityQuestionAnswer" class="form-group form-row required">
    <label for="challengeAnswer" class="col-md-4 col-form-label">Answer</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.challengeAnswer"
        type="text"
        class="form-control"
        name="challengeAnswer"
        id="challengeAnswer"
        #challengeAnswer="ngModel"
        required
        [readonly]="editAuthenticatedUser"
      />

      <div *ngIf="form.submitted && challengeAnswer.invalid" class="invalid-feedback">
        Please provide a challenge answer
      </div>
    </div>
  </div>

  <div *ngIf="formFieldsEnabled.timeZone" class="form-group form-row required">
    <label for="timeZone" class="col-md-4 col-form-label">Time Zone</label>
    <div class="col-md-8">
      <select
        class="form-select"
        name="timeZone"
        id="timeZone"
        [(ngModel)]="user.timezone"
        #timeZoneModel="ngModel"
        [disabled]="editAuthenticatedUser"
        required
      >
        <option [ngValue]="null" disabled>Please select a time zone</option>
        <option *ngFor="let timeZone of timeZones" [ngValue]="timeZone.key">{{ timeZone.value }}</option>
      </select>
      <div *ngIf="form.submitted && timeZoneModel.invalid" class="invalid-feedback">Please provide a time zone</div>
    </div>
  </div>

  <div class="form-group form-row required">
    <label for="emailId" class="col-md-4 col-form-label">Email</label>
    <div class="col-md-8">
      <input
        type="emailId"
        name="emailId"
        id="emailId"
        [email]="true"
        [(ngModel)]="user.emailId"
        class="form-control"
        #emailId="ngModel"
        [readonly]="editAuthenticatedUser"
        required
      />

      <div *ngIf="form.submitted && emailId.invalid" class="invalid-feedback">Please enter a valid email address</div>
    </div>
  </div>

  <div *ngIf="formFieldsEnabled.telePin" class="form-group form-row required">
    <label for="telePin" class="col-md-4 col-form-label">Tele PIN</label>
    <div class="col-md-8">
      <input
        [(ngModel)]="user.telePin"
        type="text"
        class="form-control"
        name="telePin"
        id="telePin"
        #telePin="ngModel"
        required
        [readonly]="editAuthenticatedUser"
        maxlength="4"
      />

      <div *ngIf="form.submitted && telePin.invalid" class="invalid-feedback">Please provide a tele PIN</div>
    </div>
  </div>

  <div class="form-group form-row">
    <label for="mobileNo" class="col-md-4 col-form-label">Mobile Phone</label>
    <div class="col-md-8">
      <input
        [mask]="phoneNumberMaskOptions"
        [(ngModel)]="user.mobileNo"
        type="text"
        class="form-control"
        name="mobileNo"
        id="mobileNo"
        #mobileNo="ngModel"
      />
      <div *ngIf="form.submitted && mobileNo.invalid" class="invalid-feedback">
        Please provide a valid mobile phone number
      </div>
    </div>
  </div>

  <div class="form-group form-row required">
    <label for="employer" class="col-md-4 col-form-label" for="employer">Employer</label>
    <div class="col-md-8">
      <select
        [(ngModel)]="user.employerId"
        class="form-select"
        id="employer"
        name="employer"
        #employer="ngModel"
        [disabled]="editAuthenticatedUser"
        required
      >
        <option [ngValue]="null" disabled>Please select...</option>
        <option *ngFor="let emp of employers" [ngValue]="emp.id">{{ emp.description }}</option>
      </select>

      <div *ngIf="form.submitted && employer.invalid" class="invalid-feedback">Please select an employer</div>
    </div>
  </div>

  <div class="form-group form-row required">
    <label for="jobTitle" class="col-md-4 col-form-label">Job Title</label>
    <div class="col-md-8">
      <select
        [(ngModel)]="user.jobTitle"
        (ngModelChange)="onJobTitleChange($event)"
        class="form-select"
        id="jobTitle"
        name="jobTitle"
        [disabled]="editAuthenticatedUser"
        #jobTitleModel="ngModel"
        [disabled]="editAuthenticatedUser"
        required
      >
        <option [ngValue]="null" disabled>Please select...</option>
        <option *ngFor="let j of jobTitles" [ngValue]="j.description">{{ j.description }}</option>
      </select>

      <div *ngIf="form.submitted && jobTitleModel.invalid" class="invalid-feedback">Please select a job title</div>
      <div class="text-red fst-italic" *ngIf="isCurrentRoleExternalAgencyAndJobTitleCMHCBHCM">
        {{ sudSmiAutomaticAccessMessage }}
      </div>
    </div>
  </div>

  <div *ngIf="showOtherJobTitle" class="form-group form-row required">
    <label for="otherJobTitle" class="col-md-4 col-form-label">Other Job Title</label>
    <div class="col-md-8">
      <input
        type="text"
        id="otherJobTitle"
        name="otherJobTitle"
        id="otherJobTitle"
        [(ngModel)]="user.otherJobTitle"
        class="form-control"
        [readonly]="editAuthenticatedUser"
        #otherJobTitle="ngModel"
        [disabled]="editAuthenticatedUser"
        required
      />

      <div *ngIf="form.submitted && otherJobTitle.invalid" class="invalid-feedback">Please enter a valid job title</div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-primary" [thLoadingIndicator]="submitting" type="submit">Save</button>
    <button
      type="button"
      [disabled]="submitting"
      class="btn btn-outline-primary ms-2"
      (click)="modalService.dismissAll()"
    >
      Cancel
    </button>
  </div>
</form>
